import { Injectable } from "@angular/core";
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from "@angular/router";
import { Auth } from "aws-amplify";
import { ConnectionService } from "../services/connection.service";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {
    constructor(private connectionService: ConnectionService) { }

    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Promise<boolean | UrlTree> {
        return new Promise((resolve) =>
            Auth.currentCredentials()
                .then((d) => {
                    this.connectionService.isAuthenticated = d.authenticated;
                    this.connectionService.configureAuthMode();
                })
                .catch((e) => console.log("amplify connection error: ", e))
                .finally(() => {
                    return resolve(true);
                }),
        );
    }
}
